/**
 * 批量上传文件行：创建、唯一键与轴重置。
 * 三轴状态（校验 / 上云 / 落库）分离，避免单一 status 字符串难以表达组合态。
 */

export function buildFileRowId(resourceType, fileName) {
  return `${resourceType}::${fileName}`
}

/** 判断两次选择的本地文件是否为同一物理文件（用于重复选择提示） */
export function isSameFileContent(a, b) {
  if (!a || !b) return false
  return (
    a.name === b.name &&
    a.size === b.size &&
    a.lastModified === b.lastModified
  )
}

/** 用新 File 替换行内容并重置上云/落库轴；校验由调用方重新触发 */
export function applyNewRawToRow(row, raw) {
  revokeRowPreview(row)
  row.raw = raw
  row.name = raw.name
  row.size = raw.size
  row.mimeType = raw.type
  row.localUrl = URL.createObjectURL(raw)
  row.addedAt = Date.now()
  // 替换进来的是本地另选的文件，不再属于原来的批次。
  row.batchName = ''
  resetCloudAndSaveAxes(row)
}

export function createFileRow({ raw, resourceType, uid, batchName = '' }) {
  const name = raw.name
  return {
    uid,
    id: buildFileRowId(resourceType, name),
    name,
    size: raw.size,
    mimeType: raw.type,
    raw,
    resourceType,
    /** 从批次 zip 拆出来时记下批次文件名，出错时能找回是哪一批的哪个包。 */
    batchName,
    localUrl: URL.createObjectURL(raw),
    addedAt: Date.now(),

    validateStatus: 'pending',
    validateMessage: '',
    /** 校验代次：异步校验返回时比对，丢弃过期结果 */
    validationToken: 0,

    cloudStatus: 'idle',
    cloudProgress: 0,
    cloudRetryCount: 0,
    cloudErrorKind: '',
    cloudErrorMessage: '',
    publicUrl: '',
    uploadUrl: '',
    headers: null,
    uploadedAt: null,
    cancelSource: null,

    saveStatus: 'idle',
    saveErrorMessage: '',
    savedResourceId: null
  }
}

/** 替换文件内容时重置云与落库轴，校验轴由调用方重新触发 */
export function resetCloudAndSaveAxes(row) {
  row.cloudStatus = 'idle'
  row.cloudProgress = 0
  row.cloudRetryCount = 0
  row.cloudErrorKind = ''
  row.cloudErrorMessage = ''
  row.publicUrl = ''
  row.uploadUrl = ''
  row.headers = null
  row.uploadedAt = null
  row.cancelSource = null

  row.saveStatus = 'idle'
  row.saveErrorMessage = ''
  row.savedResourceId = null
}

export function revokeRowPreview(row) {
  if (row && row.localUrl) {
    URL.revokeObjectURL(row.localUrl)
    row.localUrl = ''
  }
}
